/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { AuthRoles } from 'jotai/auth';
import { authService } from 'services/auth/AuthService';

const isTruckUser = () => {
  const userRoles = authService.getRolesAllRealms();
  const authorizedTruckRoles: string[] = [AuthRoles.ADMIN, AuthRoles.Truck];
  return userRoles && userRoles?.some((item) => authorizedTruckRoles.includes(item));
};

export default isTruckUser;
